import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import EditHealthPlanModal from "./EditHealthPlanModal";
import FirstLineContainer from "components/common/FirstLineContainer";
import { useSelector } from "react-redux";

const EditHealthPlanConfiguration = () => {
  const { id, name } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { editable = false, row = null } = location.state || {};

  const hasHPConfigChanged = useSelector((state) => state.app.hpConfigChanged);
  const [openDialog, setOpenDialog] = useState(false); // Dialog visibility state

  const handleClose = () => {
    if (hasHPConfigChanged) {
      setOpenDialog(true); // Open dialog when there are unsaved changes
    } else {
      navigate(-1); // Navigate back if there are no unsaved changes
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false); // Close dialog without navigating
  };

  const handleContinue = () => {
    setOpenDialog(false);
    navigate(-1); // Navigate away from the page
  };

  return (
    <>
      {id && (
        <>
          <FirstLineContainer>
            <Typography variant="h6" sx={{ textAlign: "left", flex: 1 }}>
              <Box component="span" fontWeight="fontWeightBold">
                {editable ? "Editing" : "Viewing"} Health Plan Configuration -{" "}
                {name}
              </Box>
            </Typography>
          </FirstLineContainer>
          <EditHealthPlanModal
            hpcKey={id}
            handleClose={handleClose}
            editable={editable}
            gridRow={row}
          />
        </>
      )}

      {/* Unsaved Changes Dialog */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Unsaved Changes</DialogTitle>
        <DialogContent>
          You have unsaved changes related to LOB Configurations. Do you want to
          leave this page without saving?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Stay
          </Button>
          <Button onClick={handleContinue} color="secondary">
            Leave
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditHealthPlanConfiguration;
